import { NavLink } from "react-router-dom";
import styles from "./index.module.scss";
import { useAppSelector } from "../../../redux/hooks";
import { getAdminSidebar } from "../../../redux/selectors";

const SideBar = () => {
  const open = useAppSelector((state) => getAdminSidebar(state));

  return (
    <div className={styles.dashboardSideBar}>
      <div className={`${styles.sidebar} ${!open ? styles.close : ""}`}>
        <div className={styles.logoDetails}>
          <i className="bx bxl-c-plus-plus"></i>
          <span className={styles.logo_name}>TAMARA</span>
        </div>
        <ul className={styles.navLinks}>
          <li>
            <NavLink
              className={({ isActive }) =>
                isActive ? styles.activeNavLink : ""
              }
              to={"/admin/add"}
            >
              <i className="fas fa-folder"></i>
              <span className={styles.link_name}>Five Step</span>
            </NavLink>
            <ul className={`${styles.subMenu} ${styles.blank}`}>
              <li>
                <NavLink to="/admin/add" className={styles.link_name}>
                  Добавить новую деталь
                </NavLink>
              </li>
            </ul>
          </li>
          <li>
            <NavLink
              className={({ isActive }) =>
                isActive ? styles.activeNavLink : ""
              }
              to={"/admin/catalogs"}
            >
              <i className="fa-solid fa-table-cells-large"></i>
              <span className={styles.link_name}>Перейти к каталогам</span>
            </NavLink>
            <ul className={`${styles.subMenu} ${styles.blank}`}>
              <li>
                <NavLink to="/admin/catalogs" className={styles.link_name}>
                  Перейти к каталогам
                </NavLink>
              </li>
            </ul>
          </li>
          <li>
            <NavLink
              className={({ isActive }) =>
                isActive ? styles.activeNavLink : ""
              }
              to={"/admin/newDetail"}
            >
              <i className="fa-solid fa-plus"></i>
              <span className={styles.link_name}>
                Добавить Деталь к каталогу
              </span>
            </NavLink>
            <ul className={`${styles.subMenu} ${styles.blank}`}>
              <li>
                <NavLink to="/admin/newDetail" className={styles.link_name}>
                  Добавить Деталь к каталогу
                </NavLink>
              </li>
            </ul>
          </li>
          <li>
            <NavLink
              className={({ isActive }) =>
                isActive ? styles.activeNavLink : ""
              }
              to={"/admin/"}
            >
              <i className="fa-sharp fa-solid fa-dumpster"></i>
              <span className={styles.link_name}>Все товары</span>
            </NavLink>
            <ul className={`${styles.subMenu} ${styles.blank}`}>
              <li>
                <NavLink to="/admin/" className={styles.link_name}>
                  Все товары
                </NavLink>
              </li>
            </ul>
          </li>
          <li>
            <NavLink
              className={({ isActive }) =>
                isActive ? styles.activeNavLink : ""
              }
              to={"/"}
            >
              <i className="fa-solid fa-house"></i>
              <span className={styles.link_name}> Домашняя страница</span>
            </NavLink>
            <ul className={`${styles.subMenu} ${styles.blank}`}>
              <li>
                <NavLink to="/" className={styles.link_name}>
                  Домашняя страница
                </NavLink>
              </li>
            </ul>
          </li>
        </ul>
      </div>
    </div>
  );
};

export default SideBar;
